export default __webpack_public_path__ + "static/media/camiones.cb2a9597.svg";